<template>
    <zen-one :showuserinfo="false" title="Sistem Hasil Bersepadu Kedah (iHasil)" :crumbs="crumbs">
         <z-page title=" Senarai Penyata Bank">
            <w-form ref="dform" @validate="search">
                
                <w-flex class="mt3">
                    <div class="xs3 mr3">
                        <w-input v-model="cari.nama_fail" label="Nama Fail Penyata Bank" />
                    </div>
                    <div class="xs3 mr3">
                      <w-input v-model="cari.tarikh" required label="Tarikh Transaksi " type="date"  /> 
                    </div>
                    
                </w-flex>

            </w-form>

            <w-flex class="mt1 mb3" justify-end>
                <div class="mt2 text-right">
                    <w-button class="ml1" v-on:click="reset()" bg-color="warning">
                        <w-icon>fal fa-redo-alt</w-icon>&nbsp;Reset
                    </w-button>
                    <w-button class="ml1 " @click="$refs.dform.validate()">
                        <w-icon>fal fa-search</w-icon>&nbsp;Cari
                    </w-button>
                </div>
            </w-flex>

            <z-table title="Senarai Penyata Bank" :headers="table.headers" :items="table.items" :meta="table.meta" class="">
                
            </z-table>

            <!-- <w-flex class="mt1 mb3" justify-center>
                <div class="mt2 text-center">
                    <w-button bg-color="success" class="mr3" @click="cetak()">
                        <w-icon>fal fa-print</w-icon>&nbsp;Cetak
                    </w-button>
                </div>
            </w-flex> -->
        </z-page>
    </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZenOne from '@/Shared/ZenOne'
import ZResource from '@/Modules/z-resource-service'


export default {
  extends: ZResource,
  components: {
    // ZenOne
  },
  props: {
    items: [Array, Object],
    auth: [Array, Object],
  },
  data() {
    return {
        resourceurl: this.service_penyata+'penyata/senarai-bank',
        reload: true,
        status: [
            {
                value: 1,
                label: 'Aktif',
            },
            {
                value: 2,
                label: 'Tidak Aktif',
            },
        ],
        crumbs: [
            { label: 'iHasil', route: '/' },
              { label: 'Penyata Penyesuaian', route: '/penyesuaian' },
              { label: 'Senarai Penyata Bank', route: '/penyesuaian/senarai-bank' },
          ],
        cari : {
            tarikh: '', 
            nama_fail: '',
            proses: '',
            status: '',
        },
    }
  },
  methods: {

    search() {
      this.$inertia.visit(window.route('akaun_belum_terima.abt_1')+'?bulan='+this.cari.bulan+'&tahun='+this.cari.tahun, {preserveScroll:true})
    },

    reset(){
      this.cari = {bulan: '', tahun: ''}
      this.search()
    },

    cetak() {
        window.location.href = this.service_tunggakan+'abt1/cetak?user='+this.auth.user.name;
    },
  },
  watch: {
  },
  mounted() {
    // override default setting
    // this.getData();
    this.dialog.width = 900
    this.cari = location.search.slice(1).split('&').map(p => p.split('=')).reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
    if(this.cari.bulan == 'undefined'){this.cari.bulan = ''}
    if(this.cari.tahun == 'undefined'){this.cari.tahun = ''}
    // console.log(this.auth.user);
  },
}
</script>
<style>
.w-select__menu {
    z-index: 999999;
}
</style>